<script>
  export default {
    props: ["competitionsTypes"],
    data() {
      return {
        isLoadingYears: true,
        years: [],
        isNavigating: true,
        isDragging: false,
        startX: 0,
        scrollLeft: 0,
        showLeftFade: false,
        showRightFade: true,
        hasMoved: false,
      };
    },
    computed: {
      navYears() {
        const yearsExisting = this.years.map((year) => {
          const data = this.getYearData(+year._id);
          data.contest = year.allData.map(({ _id }) => _id);
          return data;
        });

        return yearsExisting;
      },
      currentType() {
        return this.$route.params?.type;
      },
      screen() {
        return this.$store.state.screen.width;
      },
      yearActive() {
        return this.navYears.find(({ contest }) => Array.isArray(contest) && contest.includes(this.$route.params?.id)) || {};
      },
      isLargeScreen() {
        return this.screen > 1024;
      },
      dataYears() {
        return this.navYears.reverse();
      },
      isYearlyTypeSelected() {
        return this.currentType === "yearly";
      },
    },
    watch: {
      currentType: {
        handler() {
          if (this.isNavigating) return;
          this.setContestInitial();
          this.scrollToYearly();
          this.scrollToStart();
        },
        immediate: false,
      },
      isYearlyTypeSelected: {
        handler(newVal) {
          if (newVal && !this.isLoadingYears) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.handleScroll();
              }, 100);
            });
          }
        },
        immediate: false,
      },
      dataYears: {
        handler(newVal) {
          if (newVal && newVal.length > 0 && this.isYearlyTypeSelected) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.handleScroll();
              }, 100);
            });
          }
        },
        immediate: false,
      },
    },
    methods: {
      scrollToYearly() {
        if (!this.isLargeScreen && this.isYearlyTypeSelected) {
          this.$nextTick(() => {
            const container = this.$refs.navYears;
            if (container) {
              container.scrollTo({
                left: container.clientWidth / 2.4,
                behavior: "smooth",
              });
            }
          });
        }
      },
      scrollToStart() {
        this.$nextTick(() => {
          if (!this.isYearlyTypeSelected) {
            const container = this.$refs.navYears;
            if (container) {
              container.scrollTo({
                left: 0,
                behavior: "smooth",
              });
            }
          }
        });
      },
      getYearData(year) {
        const text = (new Date().getFullYear() >= year ? "GANADORAS " : "PRÓXIMAS GANADORAS ") + year;
        return { text, year: year + "" };
      },
      handleShowArrow(index) {
        return this.isYearlyTypeSelected && index === 2 && this.screen < 1300;
      },
      verifyExistYear(years, toVerify) {
        return years.some((year) => year._id === toVerify);
      },
      async getYearsWithCompetition() {
        try {
          this.isLoadingYears = true;
          const { data = {} } = await this.$axios.get("/contest/years", { params: { type: this.currentType || "yearly" } });
          const { years = [] } = data;

          this.years = years;
          this.isLoadingYears = false;
        } catch (error) {
          console.log(error);
        }
      },
      async getLastActiveOrFinished() {
        try {
          const { data = {} } = await this.$axios.get("/contest/last");
          const { lastCompetition } = data;

          return lastCompetition;
        } catch (error) {
          console.log(error);
        }
      },
      async goToLastContest() {
        const competition = await this.getLastActiveOrFinished();

        if (!competition) {
          return;
        }

        const year = new Date(competition.startDate).getFullYear().toString();

        this.$router
          .push({
            name: "CompetitionSelected",
            params: {
              type: competition.typeContest,
              year: year,
              id: competition._id,
            },
          })
          .finally(() => {
            this.isNavigating = false;
          });
      },
      async setContestInitial() {
        await this.getYearsWithCompetition();

        const lastYear = this.years.at(-1);

        if (!lastYear || !Array.isArray(lastYear.allData) || lastYear.allData.length === 0) {
          this.$router.push({ name: "competition", params: { type: this.currentType } });
          return;
        }

        const lastItemId = lastYear.allData.at(-1)._id;

        this.$router.push({
          name: "CompetitionSelected",
          params: {
            type: this.currentType,
            year: +lastYear._id,
            id: lastItemId,
          },
        });
      },
      handleMouseDown(e) {
        const carousel = this.$refs.carousel;
        if (!carousel) return;

        this.isDragging = true;
        this.hasMoved = false;
        carousel.style.cursor = "grabbing";
        carousel.style.userSelect = "none";
        carousel.style.scrollBehavior = "auto";
        this.startX = e.pageX - carousel.offsetLeft;
        this.scrollLeft = carousel.scrollLeft;
      },
      handleMouseLeave() {
        if (!this.isDragging) return;
        this.isDragging = false;
        const carousel = this.$refs.carousel;
        if (carousel) {
          carousel.style.cursor = "grab";
          carousel.style.userSelect = "auto";
          carousel.style.scrollBehavior = "smooth";
        }
      },
      handleMouseUp() {
        this.isDragging = false;
        const carousel = this.$refs.carousel;
        if (carousel) {
          carousel.style.cursor = "grab";
          carousel.style.userSelect = "auto";
          carousel.style.scrollBehavior = "smooth";
        }
      },
      handleMouseMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        const carousel = this.$refs.carousel;
        if (!carousel) return;

        const x = e.pageX - carousel.offsetLeft;
        const walk = (x - this.startX) * 2;

        if (Math.abs(walk) > 5) {
          this.hasMoved = true;
        }

        carousel.scrollLeft = this.scrollLeft - walk;
      },
      handleYearClick(e, year) {
        if (this.hasMoved) {
          e.preventDefault();
          return;
        }
      },
      handleCompetitionTypeChange(type) {
        if (type.type === this.currentType) {
          return;
        }

        this.$router.push({
          name: "YearCompetition",
          params: {
            type: type.type,
            year: this.yearActive.year || this.dataYears[0]?.year,
            id: this.yearActive.contest?.[0] || this.dataYears[0]?.contest?.[0],
          },
        });
      },
      handleScroll() {
        const carousel = this.$refs.carousel;
        if (!carousel) return;

        const scrollLeft = carousel.scrollLeft;
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;

        this.showLeftFade = scrollLeft > 3;

        this.showRightFade = scrollLeft < maxScroll - 3;
      },
      setupScrollListener() {
        this.$nextTick(() => {
          const carousel = this.$refs.carousel;
          if (carousel) {
            carousel.addEventListener("scroll", this.handleScroll);
            this.handleScroll();
          }
        });
      },
      scrollToNextItem() {
        const carousel = this.$refs.carousel;
        if (!carousel) return;
        const items = carousel.querySelectorAll(".rankingView__year");
        if (!items.length) return;

        const scrollLeft = carousel.scrollLeft;
        const carouselLeft = carousel.getBoundingClientRect().left;

        for (let item of items) {
          const itemRect = item.getBoundingClientRect();
          const itemLeft = itemRect.left - carouselLeft + scrollLeft;

          if (itemLeft > scrollLeft + 10) {
            carousel.scrollTo({
              left: itemLeft,
              behavior: "smooth",
            });
            break;
          }
        }
      },
      scrollToPrevItem() {
        const carousel = this.$refs.carousel;
        if (!carousel) return;

        const items = carousel.querySelectorAll(".rankingView__year");
        if (!items.length) return;

        const scrollLeft = carousel.scrollLeft;
        const carouselLeft = carousel.getBoundingClientRect().left;

        for (let i = items.length - 1; i >= 0; i--) {
          const item = items[i];
          const itemRect = item.getBoundingClientRect();
          const itemLeft = itemRect.left - carouselLeft + scrollLeft;

          if (itemLeft < scrollLeft - 10) {
            carousel.scrollTo({
              left: itemLeft,
              behavior: "smooth",
            });
            break;
          }
        }
      },
    },
    beforeMount() {
      this.goToLastContest();
    },
    async mounted() {
      await this.getYearsWithCompetition();
      this.setupScrollListener();
    },
    beforeUnmount() {
      const carousel = this.$refs.carousel;
      if (carousel) {
        carousel.removeEventListener("scroll", this.handleScroll);
      }
    },
  };
</script>

<template>
  <section class="rankingView">
    <div class="rankingView__navYears" ref="navYears">
      <div class="rankingView__typeOptions">
        <div
          v-for="(type, index) in competitionsTypes"
          :class="`rankingView__type ${type.type === currentType ? 'rankingView__type--active' : ''}`"
          :key="index"
          :style="type.type === currentType ? 'pointer-events: none;' : ''"
          @click="handleCompetitionTypeChange(type)"
        >
          <span class="rankingView__yearDate">{{ type.name }}</span>
          <iconic name="arrowright" class="rankingView__arrowIcon" v-if="handleShowArrow(index)"></iconic>
        </div>
      </div>
      <div class="rankingView__arrow" v-if="isYearlyTypeSelected && !isLoadingYears && screen >= 1300">
        <iconic name="arrowright" class="rankingView__arrowIcon"></iconic>
      </div>
      <div
        class="rankingView__carouselWrapper"
        :class="{
          'rankingView__carouselWrapper--showLeft': showLeftFade,
          'rankingView__carouselWrapper--showRight': showRightFade,
        }"
        v-show="isYearlyTypeSelected && !isLoadingYears && dataYears.length"
      >
        <iconic name="arrowright" class="rankingView__carouselArrow" v-if="showRightFade && isLargeScreen" @click.native="scrollToNextItem" />
        <iconic name="arrowleft" class="rankingView__carouselLeftArrow" v-if="showLeftFade && isLargeScreen" @click.native="scrollToPrevItem" />
        <div class="rankingView__carousel" ref="carousel" @mousedown="handleMouseDown" @mouseleave="handleMouseLeave" @mouseup="handleMouseUp" @mousemove="handleMouseMove">
          <router-link
            v-for="(year, index) in dataYears"
            :class="`rankingView__year ${year.year === yearActive.year ? 'rankingView__year--active' : ''}`"
            :key="index"
            :to="year.disabled ? '' : { name: 'CompetitionSelected', params: { year: year.year, id: year.contest.at(-1) } }"
            :disabled="year.disabled"
            @click="handleYearClick($event, year)"
            @dragstart.prevent
          >
            <span class="rankingView__yearDate">{{ year.text }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </section>
</template>

<style lang="scss" scoped>
  .rankingView {
    $diagonal: 15deg;
    $radiusItems: $radius-4;

    @include Flex(column);
    width: 100%;
    gap: $space-16;

    &__navYears {
      position: relative;
      @include Flex(row, unset, center);
      width: 100%;
      height: 42px;
      padding: 0 3px;
      gap: $space-20;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
    &__arrowIcon {
      z-index: 1;
    }
    &__typeOptions {
      @include Flex();
      width: unset;
      height: 100%;
      gap: $space-12;
      flex-shrink: 0;
    }
    &__carousel {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
      width: auto;
      min-width: 0;
      gap: $space-16;
      overflow-x: visible;
      overflow-y: hidden;
      scroll-behavior: smooth;
      flex-shrink: 0;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
    &__arrow {
      @include Flex();
      width: 20px;
      font-size: 20px;
      color: #8a8a8d;
      flex-shrink: 0;
    }
    &__carouselWrapper {
      position: relative;
      width: auto;
      height: 100%;
      flex-shrink: 0;
      min-width: 0;
      display: flex;
      align-items: center;
      &:hover .rankingView__carouselArrow,
      &:hover .rankingView__carouselLeftArrow {
        opacity: 1;
      }

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 40px;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.53) 38%, #fff 100%);
        z-index: 3;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 40px;
        background: linear-gradient(270deg, #fff 21.63%, rgba(255, 255, 255, 0) 100%);
        z-index: 3;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &--showLeft::before {
        opacity: 1;
      }

      &--showRight::after {
        opacity: 1;
      }
    }
    &__carouselArrow {
      opacity: 0;
      position: absolute;
      right: -5px;
      z-index: 5;
      font-size: 16px;
      color: #3d3d3d;
      transition: all 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        transform: scale(1.1);
      }
    }
    &__carouselLeftArrow {
      opacity: 0;
      position: absolute;
      left: -5px;
      z-index: 5;
      font-size: 16px;
      color: #3d3d3d;
      transition: all 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        transform: scale(1.1);
      }
    }
    &__type,
    &__year {
      position: relative;
      overflow: hidden;
      @include Flex(row, space-between, center);
      height: 95%;
      width: auto;
      text-transform: uppercase;
      font-family: $sec_fontBold;
      padding: 10px 25px;
      font-size: 14px;
      text-decoration: none;
      border-radius: 50px;
      color: #272727;
      cursor: pointer;
      user-select: none;
      transition: all 0.3s ease-in-out;
      flex-shrink: 0;
      white-space: nowrap;
      background: linear-gradient(
        87.42deg,
        rgba(251, 243, 166, 0.2) 1.24%,
        rgba(253, 229, 127, 0.2) 4.09%,
        rgba(241, 211, 113, 0.2) 5.04%,
        rgba(202, 155, 67, 0.2) 8.84%,
        rgba(179, 120, 38, 0.2) 11.69%,
        rgba(170, 107, 28, 0.2) 13.59%,
        rgba(181, 123, 41, 0.2) 16.45%,
        rgba(209, 165, 75, 0.2) 23.1%,
        rgba(253, 229, 127, 0.2) 31.65%,
        rgba(251, 238, 152, 0.2) 38.31%,
        rgba(251, 243, 166, 0.2) 43.06%,
        rgba(253, 229, 127, 0.2) 66.83%,
        rgba(245, 218, 118, 0.2) 67.78%,
        rgba(213, 170, 79, 0.2) 72.53%,
        rgba(190, 135, 51, 0.2) 76.33%,
        rgba(176, 114, 34, 0.2) 79.18%,
        rgba(171, 107, 28, 0.2) 82.03%,
        rgba(173, 110, 30, 0.2) 83.94%,
        rgba(181, 121, 40, 0.2) 85.84%,
        rgba(193, 140, 55, 0.2) 87.74%,
        rgba(211, 167, 76, 0.2) 89.64%,
        rgba(234, 200, 104, 0.2) 91.54%,
        rgba(253, 229, 127, 0.2) 92.49%,
        rgba(251, 236, 147, 0.2) 94.39%,
        rgba(251, 242, 161, 0.2) 96.29%
      );
      .rankingView__yearDate {
        position: relative;
        z-index: 2;
      }
      &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: $primary-color;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        border-radius: inherit;
      }
      &:hover::before {
        opacity: 1;
      }
      &:hover {
        color: white;
        box-shadow: 0px 1px 4px 0px #b57b2980;
      }
      &--active {
        color: white;
        background: $primary-color;
      }
    }
    &__year {
      width: auto;
      padding: 10px $space-20;
      color: #272727;
      transition: all 0.3s ease-in-out;
      -webkit-user-drag: none;
      -webkit-touch-callout: none;

      &--active {
        border: none;
        background: linear-gradient(to right, #bf953f, #fcf6ba, #b38728, #fbf5b7, #aa771c);
      }
      &::before {
        background: linear-gradient(to right, #bf953f, #fcf6ba, #b38728, #fbf5b7, #aa771c);
      }

      &:hover {
        color: #272727;
      }
    }
    @media (min-width: 500px) {
      &__navYears {
        justify-content: center;
      }
    }
    @media (min-width: 1024px) {
      &__navYears {
        overflow: visible;
      }
      &__carouselWrapper {
        width: 40%;
        flex-shrink: 1;
        min-width: 0;
      }
      &__carousel {
        width: 100%;
        min-width: 0;
        overflow-x: auto;
        cursor: grab;
        flex-shrink: 1;

        &:active {
          cursor: grabbing;
        }
      }
      &__type,
      &__year {
        font-size: 18px;
      }
    }
  }
</style>
